"use client";

import { cn } from "@/lib/utils";
import type { CustomLocation, MapAreaId } from "@/utils/location";
import Image from "next/image";

type LocationSelectorTriggerContentProps = {
  effectiveCurrentArea: MapAreaId;
  effectiveCustomLocation: CustomLocation | null;
  label?: string;
  labelClassName?: string;
  iconWrapperClassName?: string;
  hideImageOnError?: boolean;
  priority?: boolean;
};

export function LocationSelectorTriggerContent({
  effectiveCurrentArea,
  effectiveCustomLocation,
  label,
  labelClassName,
  iconWrapperClassName,
  hideImageOnError = false,
  priority = false,
}: LocationSelectorTriggerContentProps) {
  const hasCustomLocationSelected = effectiveCustomLocation != null;

  return (
    <>
      <div
        className={cn(
          "shrink-0 size-8 rounded-sm overflow-clip",
          iconWrapperClassName,
        )}
      >
        <Image
          src={
            hasCustomLocationSelected
              ? "/search/search-custom.png"
              : `/search/search-${effectiveCurrentArea}.png`
          }
          alt=""
          width={32}
          height={32}
          className="rounded-sm"
          sizes="32px"
          priority={priority || undefined}
          onError={
            hideImageOnError
              ? (e) => {
                  e.currentTarget.style.display = "none";
                }
              : undefined
          }
        />
      </div>
      {label && <span className={labelClassName}>{label}</span>}
    </>
  );
}
